<div>
  <div class="progress loader-overlay" [class.hidden]="!(show | async)">
    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
      {{ message | async }}
    </div>
  </div>
</div>
